module.exports = __webpack_public_path__ + "img/photo.8325c13d.png";